import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'searchFilter' })
export class SearchFilterPipe implements PipeTransform {
  transform(list: any[], filterText: string): any {
    if ((list === null && list.length < 1) || filterText === '' || filterText === undefined) {
      return list;
    }
    return list ? list.filter(item => item.name.search(new RegExp(filterText, 'i')) > -1) : [];
  }
}
